import { useData } from "@hooks/useData";
import Http from "@core/fetch";
import { iTopChainsData, TopChainsData } from "@models/TopChainsData";
import { components } from "@apiSchema";

async function getFireflyChains(): Promise<iTopChainsData> {
    const data: components["schemas"]["ChainBaseViewModel"][] = await Http.get('top chains get all');
    return new TopChainsData({ apiModel: data });
}

export default function useFireflyChains() {
    return useData(new TopChainsData(), getFireflyChains);
}
